import { httpClient } from '@/src/@core/lib/httpClient'
import type { EmailAuditLogListParams, EmailAuditLogListResponse } from '@/src/types/apps/emailAuditTypes'

const BASE = '/resto365-email-audit-logs'

export const emailAuditLogService = {
  async list(params: EmailAuditLogListParams): Promise<EmailAuditLogListResponse> {
    const query: Record<string, string> = {
      page: (params.page + 1).toString(),
      pageSize: params.pageSize.toString()
    }
    if (params.recipient) query.recipient = params.recipient
    if (params.dateFrom) query.dateFrom = params.dateFrom
    if (params.dateTo) query.dateTo = params.dateTo
    if (params.triggerEvent) query.triggerEvent = params.triggerEvent
    if (params.restaurantId != null) query.restaurantId = params.restaurantId.toString()

    const { data } = await httpClient.get<{ data: EmailAuditLogListResponse }>(BASE, { params: query })

    return data.data
  }
}
